import endpointMapper from '../_endpoints'
import { addRecentlyApp } from '../_redux/actions/recentlyAppsActions'
import { removeAppFromIframe } from '../_redux/actions/iframeActions'
import { APPLICATION_BEHAVIOUR } from '../_enums'
import { usePost } from '../_hooks/usePost'
import { useDispatch } from 'react-redux'

export const useRecentlyOpenedAppsServices = () => {
  const [, addRecentlyOpened] = usePost()
  const dispatch = useDispatch()
  const userProfile = JSON.parse(localStorage.getItem('userInfoData'))

  const addRecentlyOpenedApp = (item) => {
    const result = addRecentlyOpened({
      url: endpointMapper.userApplications.createUserApplication,
      data: {
        UserSid: userProfile?.sid,
        applicationId: item.id,
        eventType: APPLICATION_BEHAVIOUR.RECENTLY_OPENED_APPS
      }
    })

    dispatch(addRecentlyApp(item))
  }

  return { addRecentlyOpenedApp }
}
